import Vue from "vue";
// 自定义组件防抖
Vue.directive('debounce', {
    inserted: function (el, binding) {
      const [fn, event, time] = binding.value
      let timer
      el.addEventListener(event, () => {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
          fn()
        }, time)
      })
    }
  })


// 自定义节流
Vue.directive('throttle', {
    inserted: function (el, binding) {
      const [fn, event, time] = binding.value
      let timer
      el.addEventListener(event, () => {
        if (timer) return
        timer = setTimeout(() => {
          fn()
          timer = null
        }, time)
      })
    }
  })